import React from 'react';
import { Global } from '@emotion/core';
import Header from './header';
import { GLOBAL_STYLES } from '../styles/global-styles';
import COLORS from '../styles/colors';

const Layout: React.FC = ({ children }) => (
  <>
    <Global styles={GLOBAL_STYLES} />
    <Header />
    <div
      css={{
        margin: `0 auto`,
        maxWidth: 506,
        padding: `0 1rem 1.45rem`,
        backgroundColor: COLORS.wildSand
      }}
    >
      <main>{children}</main>
    </div>
  </>
);

export default Layout;
